import { configureStore } from '@reduxjs/toolkit';

// Accounts Reports Reducers

// Admin Management Reducers
import SetUserRightsReducer from '../features/AdminManagement/setUserRightsSlice';
import departmentReducer from '../features/AdminManagement/departmentSlice';
import unitsReducer from '../features/AdminManagement/unitsSlice'
import shiftsReducer from '../features/AdminManagement/shiftsSlice';
import allowancesReducer from '../features/AdminManagement/allowancesSlice';
import leavesReducer from '../features/AdminManagement/leaveSlice';
import designationSlice from '../features/AdminManagement/designationsSlice';
import gazettedHolidaysReducer from '../features/AdminManagement/gazettedHolidaysSlice';
import advanceSkipReducer from '../features/AdminManagement/advanceSkipSlice';

// General Management Reducers

// Payroll Management
import EmployeeReducer from '../features/PayrollManagement/employeeSlice';
import AttendanceReducer from '../features/PayrollManagement/attendanceSlice';
import salaryReducer from '../features/PayrollManagement/salarySlice';
import empAdvanceReducer from '../features/PayrollManagement/empAdvanceSlice'
import resignReducer from '../features/PayrollManagement/resignSlice';
import overTimeReducer from '../features/PayrollManagement/overTimeSlice'
import empPaidLeavesReducer from '../features/PayrollManagement/empPaidLeavesSlice';

// Stock Management

// Stock Reports

// // Setup Reducers
import authReducer from '../features/auth/authSlice'
import menuReducer from '../features/menu/menuSlice'

// // Useable Reducers
import useableReducer from '../features/setup/useableSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    menus: menuReducer,
    ru: useableReducer,
    sur: SetUserRightsReducer,
    units: unitsReducer,
    shifts: shiftsReducer,
    dept: departmentReducer,
    emp: EmployeeReducer,
    att: AttendanceReducer,
    salary: salaryReducer,
    allowances: allowancesReducer,
    leaves: leavesReducer,
    empAdv: empAdvanceReducer,
    resign: resignReducer,
    desig: designationSlice,
    ot: overTimeReducer,
    empPaidLeaves: empPaidLeavesReducer,
    gazettedHolidays: gazettedHolidaysReducer,
    advSkip: advanceSkipReducer
  },
});
